<template>
  <section v-if="brochureCount" class="full-width brochure-sticky">
    <div class="container-fluid">
      <div class="row">
        <div class="col brochure-req-spacer" :class="{ 'brochure-stickyTs': brandName === Brand.Travelsphere }">
          <span :class="{disabled : !brochureCount}">{{brochureCount}} brochure(s) selected</span>
          <button :disabled="!brochureCount" @click="changeState" class="btn" aria-label="Request brochure" title="Click to request a brochure">Request Brochure(s)</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import {Brand} from './../../../brand.js';

export default {
  computed: {
    ...mapGetters('brochureRequest', ['brochureCount'])
  },
  props: {
    brandName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      Brand
    };
  },
  methods: {
    changeState() {
      this.$store.commit('brochureRequest/changeState');
      window.scroll(0, 0);
    }
  }
};
</script>